(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-bundle-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__rfBundleBound) return;
    window.__rfBundleBound = true;

    document.addEventListener('change', function (event) {
      var radio = event.target.closest && event.target.closest('[data-rf-bundle-radio]');
      if (!radio) return;
      var value = radio.value;

      document.querySelectorAll('[data-rf-bundle-radio]').forEach(function (other) {
        other.checked = other.value === value;
      });

      document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
        if (input.value === value) return;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    function rfInit() {
      var checked = document.querySelector('[data-rf-bundle-radio]:checked');
      if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rfInit);
    else rfInit();
    window.addEventListener('load', rfInit);
  })();
  } catch(e) { console.error(e); }
})();

})();
